<pos-app-spinner [show]="isBusy$ | async"></pos-app-spinner>
<div>
  <app-task-nav *ngIf="newTask" [activeNavIndex]="1"></app-task-nav>
  <div *ngIf="!newTask" class="row">
    <h3 class="text-center py-3 arb-large-heading">TASK DETAILS</h3>
  </div>

  <div *ngIf="newTask" class="col-12 d-flex justify-content-center flex-wrap p-2">
    <ul class="col-12 nav nav-tabs w-100">
      <li class="nav-item d-flex justify-content-center">
        <a class="nav-link" [ngClass]="{ active: true }" href="javascript:void(0)"> New Task </a>
      </li>
    </ul>
  </div>

  <div *ngIf="!newTask" class="border-bottom">
    <div class="row pb-1 justify-content-center mx-1">
      <div *ngIf="taskDetail?.status === 'O'" class="col-12 col-md-2 pb-1">
        <button class="btn btn-success w-100 text-uppercase" (click)="openCloseTaskModal()">Close Task</button>
      </div>
      <div *ngIf="taskDetail?.status === 'C'" class="col-12 col-md-2 pb-1">
        <button class="btn btn-primary w-100 text-uppercase btn-green" (click)="openReopenTaskModal()">Re-Open Task</button>
      </div>
      <div class="col-12 col-md-2 pb-1">
        <button class="btn btn-secondary w-100 text-uppercase" (click)="changeOrderCheck()">Link Order</button>
      </div>
      <div *ngIf="taskDetail?.status === 'O'" class="col-12 col-md-2 pb-1">
        <button class="btn btn-secondary w-100 text-uppercase" (click)="changeAssigneeCheck()">Assign To</button>
      </div>
      <div class="col-12 col-md-2 pb-1">
        <button class="btn btn-secondary w-100 text-uppercase" (click)="addCommentToTask()">Add Comment</button>
      </div>
      <div class="col-12 col-md-2 pb-1">
        <button class="btn btn-secondary w-100 text-uppercase" (click)="showTaskHistory()">Show Audit</button>
      </div>
      <div class="col-12 col-md-2 pb-1">
        <button class="btn btn-primary w-100 text-uppercase" (click)="showTaskAttachments()">
          Files <span class="badge badge-light ml-1 bg-dark">{{ allAttachments?.length }}</span>
        </button>
      </div>
    </div>
  </div>

  <div>
    <central-app-lib-task-form
      [orderDetails]="orderDetails || ''"
      [isInternalUser]="isInternalUser"
      [isShowUser]="isShowUser"
      [newTask]="newTask ? 'newTask' : false"
      [taskDetail]="taskDetail"
      (saveTaskDetails)="saveTask($event)"
      [formValid]="formValid"
      (cancel)="cancel()"
      (fetchOrder)="fetchOrderFromJDE()"
    >
    </central-app-lib-task-form>

    <div *ngIf="!newTask" class="mx-2">
      <div class="d-flex justify-content-center mx-4">
        <span><label> TASK COMMENTS </label></span>
      </div>
      <div class="row mx-2 justify-content-start">
        <div class="col-8 col-md-4 pb-1">
          <input type="text" class="form-control" [(ngModel)]="searchValue" placeholder="Search comment here..." />
        </div>
        <ag-grid-angular
          #agGrid
          class="ag-theme-balham"
          [rowData]="rowData"
          [context]="context"
          [frameworkComponents]="frameworkComponents"
          [gridOptions]="gridOptions"
          (gridReady)="onGridReady($event)"
          (cellClicked)="onCellClicked($event)"
          [domLayout]="'autoHeight'"
          [pagination]="true"
          [paginationPageSize]="5"
          [quickFilterText]="searchValue"
        ></ag-grid-angular>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-basic-title ">
      {{
        isChangeOrder
          ? 'LINK ORDER'
          : isChangeAssignee
          ? 'ASSIGN TO'
          : isShowTaskHistory
          ? 'TASK HISTORY'
          : isShowTaskAttachments
          ? 'TASK ATTACHMENTS'
          : isUpdateComment
          ? 'EDIT COMMENT'
          : isAddComment
          ? 'ADD COMMENT'
          : isCloseTask
          ? 'CLOSE TASK'
          : isReOpenClosedTask
          ? 'RE-OPEN CLOSED TASK'
          : ''
      }}
    </h3>
  </div>
  <div *ngIf="isChangeOrder">
    <div class="modal-body">
      <form [formGroup]="changeOrderForm">
        <div class="row pb-1">
          <div class="col-12 col -sm-4 label-text">Enter Order Number</div>
          <div class="col-12 col-sm-8">
            <input class="form-control" formControlName="newOrderNumber" />
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-12 col -sm-4 label-text">Enter Order Type</div>
          <div class="col-12 col-sm-8">
            <ng-select formControlName="newOrderType" [clearable]="false">
              <ng-option *ngFor="let orderType of orderTypes" [value]="orderType.OrderTypeCode">
                {{ orderType.OrderTypeDescription }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div *ngIf="validChangeOrder || linkOrderCustomerName" class="pb-2">
          <div>Customer Name</div>
          <div class="col-12 col-sm-8">
            <input class="form-control" [value]="linkOrderCustomerName" readonly="true" />
          </div>
        </div>
      </form>
      <button
        type="button"
        class="d-flex btn justify-content-start text-uppercase"
        [disabled]="taskDetail?.orderNumber === this.changeOrderForm.get('newOrderNumber').value || changeOrderForm.invalid || !validateChangeOrder"
        (click)="validateForChangeOrder()"
      >
        Validate
      </button>
      <div class="pt-2">
        <div *ngIf="taskDetail?.orderNumber == initialLinkedOrderNumber && !validChangeOrder && validateChangeOrder" class="text-danger">
          [Note: Please validate order before you update link order to this task.]
        </div>
        <div *ngIf="validChangeOrder" class="text-success">[Note: Order details provided is valid, procced to update link order to this task.]</div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn text-uppercase" [disabled]="!taskDetail?.orderNumber" (click)="removeOrderLink()">Remove link</button>
      <button type="button" class="btn text-uppercase" [disabled]="!validChangeOrder || changeOrderForm.invalid" (click)="changeOrderNumber()">
        Update
      </button>
      <button type="button" class="btn btn-cancel text-uppercase" (click)="cancelModel()">Cancel</button>
    </div>
  </div>
  <div *ngIf="isChangeAssignee">
    <div class="modal-body">
      <form [formGroup]="changeAssigneeForm">
        <div *ngIf="!isInternalUser || isShowUser" class="row px-4">
          <div class="col-12 col-md-10 pb-1">
            <div class="row pb-1">
              <div class="col-12 col-sm-3 label-text"><label>Select Store Type</label></div>
              <div class="col-12 col-sm-9">
                <input type="radio" formControlName="storeType" value="0" /><span class="px-1"></span>ARB Corporate Stores
                <span class="px-2"></span>
                <input type="radio" formControlName="storeType" value="1" /><span class="px-1"></span>Non-Corporate Stores
              </div>
            </div>
          </div>
          <div class="col-12 col-md-10 pb-1">
            <div class="row pb-1">
              <div class="col-12 col-sm-3 label-text"><label>Select Site </label></div>
              <div class="col-12 col-sm-6">
                <ng-select placeholder="Select Site" formControlName="site" [clearable]="true">
                  <ng-option *ngFor="let site of siteListFiltered" [value]="site.siteCode"
                    >{{ site.siteDescription }} ({{ site.siteCode }})</ng-option
                  >
                </ng-select>
              </div>
              <div class="col-12 col-sm-3 label-text">
                <button (click)="assignToMysite()" class="btn btn-secondary" type="button">SET TASK TO MY SITE</button>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-10 pb-1">
            <div class="row pb-1">
              <div class="col-12 col-sm-3 label-text"><label>Select Assignee</label></div>
              <div class="col-12 col-sm-6">
                <ng-select placeholder="Select Site" formControlName="assignedTo" [clearable]="false">
                  <ng-option *ngFor="let salesperson of salesPersonList" [value]="salesperson.userEmail">{{ salesperson.name }} </ng-option>
                </ng-select>
              </div>
              <div class="col-12 col-sm-3 label-text">
                <button (click)="assignToMe()" class="btn btn-secondary" type="button">ASSIGN TO ME</button>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justifiy-content-center text-danger" style="font-size: 15px">
          [Note: Tasks can be assigned to people within your site or to another site you deal with but tasks cannot be directly assigned to other
          people at other sites.]
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn text-uppercase" [disabled]="!validateChangeAssignee || changeAssigneeForm.invalid" (click)="changeAssignee()">
        Update
      </button>
      <button type="button" class="btn btn-cancel text-uppercase" (click)="cancelModel()">Cancel</button>
    </div>
  </div>
  <div *ngIf="isShowTaskHistory">
    <div class="modal-body">
      <ag-grid-angular
        #agGrid
        class="ag-theme-balham"
        [rowData]="rowDataHistory"
        [context]="context"
        [frameworkComponents]="frameworkComponents"
        [gridOptions]="gridOptionsHistory"
        (gridReady)="onGridReady($event)"
        [domLayout]="'autoHeight'"
        [pagination]="true"
        [paginationPageSize]="10"
      ></ag-grid-angular>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-cancel text-uppercase" (click)="cancelModel()">Close</button>
    </div>
  </div>
  <div *ngIf="isShowTaskAttachments">
    <div class="modal-body">
      <pos-app-attachment-files-notes
        [preloadAttachments]="allAttachments"
        [entityId]="entityId"
        [entityType]="entityType"
        (reloadedAttachments)="loadAllAttachments($event)"
        (closeActiveModal)="handleCloseModal($event)"
      ></pos-app-attachment-files-notes>
    </div>
  </div>

  <div *ngIf="isAddComment || isUpdateComment">
    <form [formGroup]="commentForm">
      <div class="modal-body">
        <angular-editor formControlName="comment" [config]="editorConfig"></angular-editor>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn text-uppercase"
          [disabled]="initialCommentValue === commentForm.get('comment')?.value || commentForm.invalid"
          (click)="addUpdateTaskComment()"
        >
          update
        </button>
        <button type="button" class="btn btn-cancel text-uppercase" (click)="cancelModel()">cancel</button>
      </div>
    </form>
  </div>
  <div *ngIf="isCloseTask">
    <div class="modal-body">
      <form [formGroup]="commentForm">
        <div class="modal-body">
          <angular-editor formControlName="comment" [config]="editorConfig"></angular-editor>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn text-uppercase" [disabled]="commentForm.invalid" (click)="closeTask()">Save</button>
          <button type="button" class="btn btn-cancel text-uppercase" (click)="cancelModel()">cancel</button>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="isReOpenClosedTask">
    <div class="modal-body">
      <form [formGroup]="commentForm">
        <div class="modal-body">
          <angular-editor formControlName="comment" [config]="editorConfig"></angular-editor>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn text-uppercase" [disabled]="commentForm.invalid" (click)="reopenTask()">Save</button>
          <button type="button" class="btn btn-cancel text-uppercase" (click)="cancelModel()">cancel</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
